<template>
    <div>
        <b-button variant="success" @click="startTraining">Start Training</b-button>
        <b-button variant="danger" @click="stopTraining">Stop Training</b-button>
        <div v-html="logs"></div>
    </div>

</template>

<script>
export default {
  name: 'ModelTrainingPage',
  created () {
  },
  methods: {
    getTrainingLog: function () {
      let trainingPageInstance = this
      trainingPageInstance.polling = setInterval(function () {
        if (!trainingPageInstance.logs) {
          trainingPageInstance.logs = ''
        }
        trainingPageInstance.logs = trainingPageInstance.logs + 'This is a new log<br>'
      }, 1000)
    },
    startTraining: function () {
      this.getTrainingLog()
    },
    stopTraining: function () {
      clearInterval(this.polling)
    }
  },
  data () {
    return {
      polling: null,
      logs: 'This is logs<br>'
    }
  }

}
</script>

<style scoped>

</style>
